"use client";

import { FaWhatsapp } from "react-icons/fa";

export default function WhatsAppFloatButton() {
  const phoneNumber = "5511940590576";
  const message = "Olá! Gostaria de mais informações.";

  const openWhatsApp = () => {
    const url = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <button
      onClick={openWhatsApp}
      className='fixed bottom-20 right-6 z-50 p-3 rounded-full bg-green-500 text-white shadow-lg hover:bg-green-600 transition-transform duration-300 hover:scale-105 animate-pulse-custom'
      aria-label='Fale conosco pelo WhatsApp'
    >
      <FaWhatsapp size={24} />
    </button>
  );
}
